import { FC } from 'react';
import { useSelector } from 'react-redux';

import { useNsTHelper } from 'src/utils/i18n';
import { PlusSubscriptionSliceStateType } from 'src/store/plusSubscription/slice';
import {
  PlusSubscriptionIsFreeTrialAvailableSelector,
  PlusSubscriptionPlanSelectionSelector,
} from 'src/store/plusSubscription/selectors';

import styles from 'src/styles/common/plusSubscription/modal/contentHeader.module.scss';
import { deCommonCurrentPartnerSelector } from 'src/store/commonPart/selector';

type Props = {
  type: Extract<PlusSubscriptionSliceStateType['modal']['type'], 'planSelection' | 'trialExpired' | 'upgradeNow'>;
};

export const PlusSubscriptionContentHeader: FC<Props> = ({ type }) => {
  const showFreeTrial = useSelector(PlusSubscriptionIsFreeTrialAvailableSelector);
  const { IsFreeTrialExpired } = useSelector(PlusSubscriptionPlanSelectionSelector);
  const { Name } = useSelector(deCommonCurrentPartnerSelector);

  let preparedType = type;

  if (type === 'planSelection') {
    if (IsFreeTrialExpired) {
      preparedType = 'trialExpired';
    } else if (!showFreeTrial) {
      preparedType = 'upgradeNow';
    }
  }

  const tHelper = useNsTHelper('plusSubscription', `modals.${preparedType}`);

  return (
    <div className={styles.contentHeader}>
      <div className={styles.title}>{tHelper('title', { partner: Name })}</div>
      <div className={styles.description}>{tHelper('description')}</div>
    </div>
  );
};
